export { TargetLink } from './targetLink.component';
